import React from "react";
import ReactStars from "react-stars";
import "./styles.css";

function StarRating({
  count = 5,
  value,
  size = 28,
  color1,
  color2,
  edit = "true",
}) {
  const style = {
    color: "#0D5C75",
    border: "1px solid #0D5C75",
  };

  const ratingChanged = (newRating) => {
  };
  return (
    <div className="AppStar">
      <ReactStars
        count={count}
        value={value}
        edit={edit}
        onChange={ratingChanged}
        size={size}
        color1={"#C2C2C2"}
        className={style}
        color2={"#0D5C75"}
        half={true}
        char="⭑"
      />
    </div>
  );
}

export default StarRating;
